import React, { useState } from 'react'
import contactImg from '../assets/conact.jpg'

export default function ContactForm() {
  const [form, setForm] = useState({ name:'', phone:'', email:'', appointmentDate:'', message:'' })
  const [sent, setSent] = useState(false)

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value })
  const submit = e => { e.preventDefault(); setSent(true) }

  return (
    <div className="flex flex-col lg:flex-row overflow-hidden" style={{background:'var(--sand)'}}>
      {/* Image */}
      <div className="lg:w-1/2 w-full">
        <img src={contactImg} alt="Join Us" className="w-full h-full object-cover" style={{minHeight:'320px'}}/>
      </div>

      {/* Form */}
      <div className="lg:w-1/2 w-full p-8 sm:p-12">
        <div className="section-tag">Get Involved</div>
        <h2 className="mb-2 leading-tight" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,38px)',fontWeight:700,color:'var(--navy)'}}>
          Join Our Mission
        </h2>
        <p className="mb-8 text-sm leading-relaxed" style={{color:'var(--muted)'}}>Fill in your details and we'll get back to you shortly.</p>

        {sent ? (
          <div className="text-center py-10">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{background:'rgba(232,103,10,0.1)'}}>
              <svg className="w-8 h-8" fill="none" stroke="var(--saffron)" strokeWidth="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <h3 className="font-bold text-xl mb-2" style={{color:'var(--navy)',fontFamily:'Playfair Display,serif'}}>Thank You!</h3>
            <p style={{color:'var(--muted)'}}>We'll be in touch with you soon.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>Full Name *</label>
                <input name="name" value={form.name} onChange={handle} placeholder="Your name" required className="sb-input"/>
              </div>
              <div>
                <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>Phone *</label>
                <input name="phone" value={form.phone} onChange={handle} placeholder="Your number" required className="sb-input"/>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>Email *</label>
                <input type="email" name="email" value={form.email} onChange={handle} placeholder="your@email.com" required className="sb-input"/>
              </div>
              <div>
                <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>Date</label>
                <input type="date" name="appointmentDate" value={form.appointmentDate} onChange={handle} className="sb-input"/>
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium mb-1.5 tracking-wide" style={{color:'var(--navy)'}}>Message *</label>
              <textarea name="message" value={form.message} onChange={handle} rows="4" placeholder="Tell us how you'd like to get involved…" required className="sb-input" style={{resize:'vertical'}}/>
            </div>
            <button type="submit" className="inline-flex items-center gap-2 text-white px-8 py-3.5 rounded-full font-semibold text-sm transition-all duration-200 hover:-translate-y-0.5"
              style={{background:'var(--saffron)',boxShadow:'0 6px 20px rgba(232,103,10,0.3)'}}>
              Send Message
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
